'use strict';
let ezease = 'power3.inOut';
gsap.to('.inscription', {
  delay: 0.3,
  duration: 0.7,
  opacity: 1,
  ease: ezease
});
let link_co = document.querySelector('.link');
link_co.addEventListener('click', (e) => {
  gsap.to('.focus', {
    duration: 0.2,
    x: '0vw',
    ease: ezease
  });
  gsap.to(".inscription", {
    duration: 0.2,
    delay: 0.2,
    opacity: 1,
    ease: ezease
  });
});
let btn_app_notif = document.querySelector('.btn__notif');
let btn_app_appli = document.querySelector('.btn__appli');
btn_app_notif.addEventListener('click', (e) => {
  btn_app_appli.classList.remove('btn__app--on');
  btn_app_notif.classList.add('btn__app--on');
  gsap.to('.focus', {
    duration: .2,
    x: "-300vw",
    ease: ezease
  });
});
btn_app_appli.addEventListener('click', (e) => {
  btn_app_notif.classList.remove('btn__app--on');
  btn_app_appli.classList.add('btn__app--on');
  gsap.to('.focus', {
    duration: .5,
    x: "-200vw",
    ease: ezease
  });
});
//CHECK DE L'ETAT DE L'APP
let app__check = document.querySelectorAll('.switch__checkbox--big');
for (let i = 0; i < app__check.length; i++) {
  let stateapp = app__check[i];
  stateapp.addEventListener('click', (e) => {
    if (stateapp.checked == true) {
      if (i == 0) {
        gsap.to('.fonction__app', {
          opacity: 1,
          ease: ezease
        });
      } else if (i == 1) {
        gsap.to('.fonction__not', {
          opacity: 1,
          ease: ezease
        });
      }
    } else if (stateapp.checked !== true) {
      if (i == 0) {
        gsap.to('.fonction__app', {
          opacity: 0.25,
          ease: ezease
        });
      } else if (i == 1) {
        gsap.to('.fonction__not', {
          opacity: 0.25,
          ease: ezease
        });
      }
    }
  });
  if (stateapp.checked !== true) {
    if (i == 0) {
      gsap.to('.fonction__app', {
        opacity: 0.25,
        ease: ezease
      });
    } else if (i == 1) {
      gsap.to('.fonction__not', {
        opacity: 0.25,
        ease: ezease
      });
    }
  }
}
//OPTION
let option = document.querySelector('.option');
let btn_option = document.querySelector('.btn__option');
let btn_opt_acti = document.querySelector('.option--on');
btn_option.addEventListener('click', (e) => {
  if (btn_option.classList.contains("option--on") == true) {
    btn_option.classList.remove("option--on");
    gsap.to('.option', {
      duration: .2,
      opacity: 0,
      ease: ezease
    });
    gsap.to('.option', {
      delay: 0,
      duration: 0,
      y: "-100vh",
      ease: ezease
    });
    gsap.to('.app--option', {
      delay: .2,
      duration: .2,
      opacity: 1,
      ease: ezease
    });
  } else {
    btn_option.classList.add("option--on");
    gsap.to('.app--option', {
      duration: .2,
      opacity: 0,
      ease: ezease
    });
    gsap.to('.option', {
      delay: 0,
      duration: 0,
      y: "115vh",

      ease: ezease
    });
    gsap.to('.option', {
      delay: .2,
      duration: .2,
      opacity: 1,
      ease: ezease
    });
  }
});
//REGEX email fonction+error
function validateEmail(email) {
  var emailReg = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
  var valid = emailReg.test(email);

  if (!valid) {
    return false;
  } else {
    return true;
  }
}

function errorInOut(msg_error) {
  let error = document.querySelector('.error');
  error.innerHTML = msg_error;
  gsap.to(".error", {
    duration: .3,
    opacity: 1,
    y: "5vh",
    ease: "power3.inOut",
  });
  gsap.to(".error", {
    delay: 4,
    duration: .3,
    opacity: 0,
    y: '0vh',
    ease: "power3.inOut"
  });
}
//FORMULAIRE inscription validation
let email_insc = document.querySelector('.email__inscription');
let email_val = document.querySelector('.email__inscription--val');
let psw_insc = document.querySelector('.mdp__inscription');
let psw_val = document.querySelector('.mdp__inscription--val');
let btn_insc = document.querySelector('.btn__insc');
btn_insc.addEventListener('click', (e) => {
  e.preventDefault();
  if (email_insc.value !== email_val.value) {
    errorInOut('Tes email ne corresponde pas !');
  } else {
    if (validateEmail(email_insc.value) == false || validateEmail(email_val.value) == false) {
      errorInOut("Tu dois remplir les champs email!");
    } else {
      if (psw_insc.value.length <= 4 || psw_val.value.length <= 4) {
        errorInOut("Ton mot de passe doit faire 5 caractère au minimum !");
      } else {
        if (psw_insc.value !== psw_val.value) {
          errorInOut("Les mots de passe ne correspondes pas !");
        } else {
          localStorage.setItem('email', email_insc.value);
          localStorage.setItem('psw', psw_insc.value);
          localStorage.setItem('insc', 'ok');
          gsap.to(".inscription", {
            duration: 0.2,
            opacity: 0,
            ease: ezease
          });
          gsap.to('.focus', {
            duration: 0.2,
            delay: 0.2,
            x: '-100vw',
            ease: ezease
          });
          gsap.to(".connexion", {
            duration: 0.2,
            delay: 0.2,
            opacity: 1,
            ease: ezease
          });
        }
      }
    }
  }
});
//FORMULAIRE connexion validation
let email_co = document.querySelector('.email__co');
let psw_co = document.querySelector('.psw__co');
let btn_co = document.querySelector('.btn__co');
btn_co.addEventListener('click', (e) => {
  e.preventDefault();
  if (email_co.value !== localStorage.getItem('email') || psw_co.value !== localStorage.getItem('psw')) {
    errorInOut("Tes identifiants ne sont pas bons !");
  } else {
    localStorage.setItem('co', 'ok');
    gsap.to(".focus", {
      duration: 0.2,
      x: "-200vw",
      ease: ezease
    });
    gsap.to(".app__nav", {
      duration: 0.2,
      y: "0",
      opacity: 1,
      ease: ezease
    });
    gsap.to(".app--option", {
      duration: 0.2,
      opacity: 1,
      ease: ezease
    });
  }
});
//CHECK CO 
if (localStorage.getItem('co') !== null) {
  gsap.to('.focus', {
    duration: 0,
    x: "-200vw"
  });
  gsap.to('.app__nav', {
    y: "0%",
    opacity: 1
  });
} else if (localStorage.getItem('insc') !== null) {
  gsap.to('.focus', {
    duration: 0,
    x: "-100vw"
  });
  gsap.to('.connexion', {
    duration: 1,
    delay: 0.3,
    opacity: 1,
    ease: ezease
  });
}

//LIGHT-MODE
let app_light = document.querySelector('.switch__lightmode');
let body = document.querySelector('body');
let fonction = document.querySelector('.fonction');
let fonction_not = document.querySelector('.fonction__notification');
let title_litle = document.querySelector('.title__applitle');
let add_buton = document.querySelector('.add');
let input_text = document.querySelectorAll('input');


app_light.addEventListener('click', (e) => {
  if (app_light.checked == true) {
    localStorage.setItem('light', 'on');
    body.classList.add('body--light');
    fonction_not.classList.add('fonction--light');
    fonction.classList.add('fonction--light');
    option.classList.add('option--light');
    title_litle.classList.add('title__applitle--light');
    add_buton.classList.add('add--light');
    for (let input_light of input_text) {
      input_light.classList.add('input--light');
    }

  } else {
    localStorage.removeItem('light');
    body.classList.remove('body--light');
    fonction_not.classList.remove('fonction--light');
    fonction.classList.remove('fonction--light');
    option.classList.remove('option--light');
    title_litle.classList.remove('title__applitle--light');
    add_buton.classList.remove('add--light');
    for (let input_light of input_text) {
      input_light.classList.remove('input--light');
    }
  }
});
if (localStorage.getItem('light') !== null) {
  document.querySelector(".switch__lightmode").checked = true;
  body.classList.add('body--light');
  fonction_not.classList.add('fonction--light');
  fonction.classList.add('fonction--light');
  option.classList.add('option--light');
  title_litle.classList.add('title__applitle--light');
  add_buton.classList.add('add--light');
  for (let input_light of input_text) {
    input_light.classList.add('input--light');
  }
}
//DECO
let deco = document.querySelector('.btn--deco');
deco.addEventListener('click', (e) => {
  localStorage.removeItem('co');
  gsap.to('.option', {
    duration: .2,
    opacity: 0,
    ease: ezease
  });
  gsap.to('.option', {
    delay: 0,
    duration: 0,
    y: "-100vh",
    ease: ezease
  });
  gsap.to(".app__nav", {
    duration: 0.2,
    y: "-100vh",
    opacity: 0,
    ease: ezease
  });
  gsap.to('.focus', {
    duration: 0,
    x: "-100vw"
  });
  gsap.to('.connexion', {
    duration: 0.3,
    opacity: 1,
    ease: ezease
  });

});
